import { useAssessmentTestInfo } from '@hooks/assessments/assessment-test-info.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(async () => {
  const { initAssessmentTest } = useAssessmentTestInfo()
  initAssessmentTest()
})
